import { render } from "./client-delete-modal.vue?vue&type=template&id=65fbeb50&scoped=true&ts=true"
import script from "./client-delete-modal.vue?vue&type=script&lang=ts"
export * from "./client-delete-modal.vue?vue&type=script&lang=ts"

import "./client-delete-modal.vue?vue&type=style&index=0&id=65fbeb50&lang=css&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65fbeb50"]])

export default __exports__